import { render, staticRenderFns } from "./PointsLog.vue?vue&type=template&id=04e0091a&"
import script from "./PointsLog.vue?vue&type=script&lang=js&"
export * from "./PointsLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports